module.exports = __webpack_public_path__ + "media/promo/panasonic/images/testm-6fbb352f0647fc3535bbf75e53d4e69b.jpg";